<template>
  <header class="mb-3 mb-lg-5 d-flex flex-column align-items-center">
    <h1 class="text-20 text-lg-32 fw-400">
      {{ title }}
    </h1>
    <span class="d-none d-lg-block bg-platform mt-3" :style="{ width: '75px', height: '4px' }"></span>
  </header>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped></style>
